import setupAccordions from './accordions'
import setupSwipers from './swipers'
import setupModals from './modals'
import setupVideos from './videos'
import menu from './menu'
import responsiveIframe from './responsive-iframe'

setupAccordions()
setupSwipers()
setupModals()
setupVideos()
menu()
responsiveIframe()